
import React, { useState, useEffect } from 'react';
import { onValue } from "firebase/database";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from '../../Shared/Button';
import './homeTeamSection.css';
import HomeTeamCard from "../HomeTeamCard";


import '../../Teams/teams.css'

import { dbRefUsers } from '../../../firebase-config';

function sortByUsername(array) {
    return array.sort((a, b) => {
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0;
    });
}

function getAieTeam(array) {
    let team = [];

    for (let i = 0; i < array.length; i++) {
        if (array[i].business === "AIE") {
            team.push(array[i]);
        }
    }
    return team;
}

const HomeTeamSection = ({ }) => {
    const [members, setMembers] = useState([]);

    useEffect(() => {
        onValue(dbRefUsers, (snapshot) => {
            const membersData = snapshot.val();
            const memberKeys = Object.keys(membersData); // Retrieve the keys/uids

            const membersWithKeys = memberKeys.map((key) => ({
                ...membersData[key],
                uid: key, // Add uid/key to each member item
            }));
            const mergedMembers = [...members, ...membersWithKeys]; // Merge the arrays
            const aieTeam = getAieTeam(mergedMembers); // Call the getAieTeam function
            setMembers(aieTeam);
        });
    }, []); // Empty dependency array for initial fetching


    return (
        <div className="section-wrapper">
            <Container>
                <Row>
                    <Col>
                        <h3>The team behind the magic</h3>
                    </Col>
                </Row>
                <Row>
                    <Col >
                        Meet our talented development team! Our team is made up of a diverse group of amazing and passionate
                        people. Developers, designers, project leaders, data scientists, business analysts and many more.
                        The door is open for anyone who wants to contribute, no matter if you only have a few hours and want to
                        explore something new or if you are an expert in your field and can join for a longer period.
                        <br />
                        RIOT Labs is nothing without its crew - sign up today and join one of the teams!
                    </Col>
                </Row>
            </Container>

            <Container className='cards'>
                <Row>
                    {Object.values(members).slice(0, 4).map(member => (
                        <Col key={'col' + member.uid + crypto.randomUUID()}>
                            <HomeTeamCard
                                key={member.uid}
                                image={member.imgUrl}
                                name={member.name}
                                title={member.title}
                            />
                        </Col>
                    ))}
                </Row>
                <Row>
                    <div className='whole-team-btn'>
                        <Button buttonStyle='blue' text='Meet the whole team' navigateTo='/about' />
                    </div>
                </Row>
            </Container>
        </div>
    );
};

export default HomeTeamSection;